import { useInfiniteQuery } from "@tanstack/react-query";
import { getProducts } from "../api/endpoints";
import { qk } from "../api/queryKeys";

export default function useProducts({ category, filters, sort }) {
  return useInfiniteQuery({
    queryKey: qk.products.list(category, filters, sort),
    queryFn: ({ pageParam = 1, signal }) =>
      getProducts({ category, filters, sort, page: pageParam, signal }),
    enabled: !!category,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || !lastPage.more_pages) return undefined;
      const pages = Array.isArray(allPages) ? allPages : [];
      return pages.length + 1;
    },
    staleTime: 5 * 60 * 1000,
  });
}
